<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <p>
            Uw mobiele elektronische apparaten zijn wereldwijd verzekerd tegen schade en diefstal voor schade door
            vallen of stoten (maximaal 2 keer per jaar, tot €&nbsp;5.000 per keer).
        </p>
        <p>
            Let op: Heeft u schade aan een mobiel apparaat? Dan laten wij ze door onze professionele reparateurs
            herstellen. Kan dat technisch niet of is dat economisch niet meer zo zinvol? Dan krijgt u een voorstel voor
            vervanging in natura. Een vervangende mobiel dus. Toch liever geld? Die dagwaarde berekenen we bij mobiele
            elektronica door elke maand 2,8% af te schrijven van de nieuwwaarde.
        </p>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <p>Niet verzekerd is schade door onder andere:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Zelf kwijtraken</list-flat-item>
            <list-flat-item>Schade door normaal gebruik, zoals krassen</list-flat-item>
            <list-flat-item>Gebrek aan het apparaat zelf</list-flat-item>
            <list-flat-item>Diefstal door eigen nalatigheid</list-flat-item>
            <list-flat-item>
                Als u binnen een jaar meer dan 2 keer een schade aan mobiele elektronica gemeld heeft en via deze
                dekking vergoed heeft gekregen
            </list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Eigen Risico">
        <p>
            Bij onze Dekking Mobiele Elektronica is het eigen risico €50. Als u bij uw Woonverzekering gekozen heeft
            voor een lager eigen risico in ruil voor een hogere premie, heeft dat geen invloed op de premie en het eigen
            risico van de Mobiele elektronica dekking.
        </p>
    </cyno-tab>
</cyno-tabset>
